export default (disposition) => {
  const typeProperties = {
    default: {
      icon: 'CircleIcon',
      color: 'grey',
    },
    acc: {
      icon: 'CheckIcon',
      color: 'success',
    },
    revision: {
      icon: 'EditIcon',
      color: 'success',
    },
    up: {
      icon: 'ArrowUpRightIcon',
      color: 'success',
    },
    down: {
      icon: 'ArrowDownRightIcon',
      color: 'warning',
    },
    parallel: {
      icon: 'ArrowRightIcon',
      color: 'success',
    },
    created: {
      icon: 'PlusIcon',
      color: 'danger',
    },
    archived: {
      icon: 'ArchiveIcon',
      color: 'primary',
    },
    unarchived: {
      icon: 'ArchiveIcon',
      color: 'accent',
    },
    send: {
      icon: 'SendIcon',
      color: 'primary',
    },
    trashed: {
      icon: 'TrashIcon',
      color: 'danger',
    }
  };

  function isCreated() {
    const createdTypes = ['created'];
    return createdTypes.includes(disposition.tipe);
  }

  // method untuk cek apakah berkas masih diverifikasi
  function isOnDisposition() {
    const onDispositionTypes = ['up', 'down', 'parallel', 'acc', 'revision'];
    return onDispositionTypes.includes(disposition.tipe);
  }

  function isLastDisposition({
    length,
    index
  }) {
    return length - 1 == index
  }

  return {
    ...disposition,
    ...(typeProperties[disposition.tipe] || typeProperties.default),
    isCreated: isCreated(),
    isOnDisposition: isOnDisposition(),
    isLastDisposition
  };
};
